import _extends from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import * as React from 'react';
import PropTypes from 'prop-types';
import { TouchableNativeFeedback, TouchableOpacity, Platform, View } from 'react-native';
var LOLLIPOP = 21;

var TouchableItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TouchableItem, _React$Component);

  function TouchableItem() {
    _classCallCheck(this, TouchableItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(TouchableItem).apply(this, arguments));
  }

  _createClass(TouchableItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          pressOpacity = _this$props.pressOpacity,
          pressColor = _this$props.pressColor,
          borderless = _this$props.borderless,
          rest = _objectWithoutProperties(_this$props, ["style", "pressOpacity", "pressColor", "borderless"]);

      if (Platform.OS === 'android' && Platform.Version >= LOLLIPOP) {
        return React.createElement(TouchableNativeFeedback, _extends({}, rest, {
          background: TouchableNativeFeedback.Ripple(pressColor, borderless)
        }), React.createElement(View, {
          style: style
        }, React.Children.only(this.props.children)));
      } else {
        return React.createElement(TouchableOpacity, _extends({}, rest, {
          rejectResponderTermination: true,
          style: style,
          activeOpacity: pressOpacity
        }), this.props.children);
      }
    }
  }]);

  return TouchableItem;
}(React.Component);

_defineProperty(TouchableItem, "propTypes", {
  onPress: PropTypes.func.isRequired,
  delayPressIn: PropTypes.number,
  borderless: PropTypes.bool,
  pressColor: PropTypes.string,
  pressOpacity: PropTypes.number,
  children: PropTypes.node.isRequired
});

_defineProperty(TouchableItem, "defaultProps", {
  pressColor: 'rgba(255, 255, 255, .4)'
});

export { TouchableItem as default };